import { Card, Stack } from "@mantine/core";
import useTransientStore from "../../../data/transcientStore";
import { useTranslation } from "../../../hooks/useTranslation";
import { ReportSectionHeader } from "../ReportSectionHeader";
import CityObjectPrintoutsSearchPage from "./CityObjectPrintoutsSearchPage";

interface SearchPrintoutsReportProps {
  onBack: () => void;
  showHeader?: boolean;
}

export default function SearchPrintoutsReport({
  onBack,
  showHeader = true,
}: Readonly<SearchPrintoutsReportProps>) {
  const selectedAddressSystemId =
    useTransientStore((state) => state.selectedAddressSystem?.id) ?? 0;
  const { getTranslation } = useTranslation({
    pageId: 512,
    addressSystemId: selectedAddressSystemId,
    autoLoad: true,
  });

  return (
    <Card withBorder radius="lg" px="xl" py="lg" shadow="sm">
      <Stack gap="md">
        {showHeader && (
          <ReportSectionHeader
            onBack={onBack}
            contextLabel={
              getTranslation("REPORTS_HUB_LABEL") || "Reports"
            }
            title={
              getTranslation("REPORTS_SEARCH_PRINTOUTS") ||
              "Search for printouts"
            }
            backLabel={
              getTranslation("REPORTS_RETURN") || "Back to reports"
            }
          />
        )}

        <CityObjectPrintoutsSearchPage />
      </Stack>
    </Card>
  );
}
